/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import styles from './Modal.module.css';
/**
 * Modal component which accepts title,body,footer as props
 * @usage : <Modal title={string} body={React.ReactElement;} footer={React.ReactElement;} hideModal={()=>void}
 */
export default function (props) {
  const { title, body, footer, hideModal, isModal } = props;
  document.body.style.overflow = isModal ? 'hidden' : 'unset';
  return (
    <>
      {isModal && (
        <div className={styles.modal} data-testid="modal">
          <div className={styles.modalContent}>
            <div
              className={styles.close}
              onClick={hideModal}
              data-testid="close"
            >
              &times;
            </div>
            <div className={styles.modalHeader}>
              <span>{title}</span>
            </div>
            <div className={styles.modalBody}>{body}</div>
            <div className={styles.modalFooter}>{footer}</div>
          </div>
        </div>
      )}
    </>
  );
}
